import axios from 'axios';
import { url } from '../config';

// Redux Actions
import { FETCH_MAIN_MENU } from '../actions/index.jsx';

// Axios Request
export const fetchMainMenu = () => {
    return function (dispatch) {
        axios
            .get(`${url}/wp-json/wp-api-menus/v2/menu-locations/main_menu`)
            .then((response) => {
                dispatch({
                    type: FETCH_MAIN_MENU,
                    payload: response.data,
                });
            });
    };
};



// WEBPACK FOOTER //
// ./src/requests/menu_request.js